import { render, staticRenderFns } from "./oneTimeLogin.vue?vue&type=template&id=8b215a18&scoped=true"
import script from "./oneTimeLogin.vue?vue&type=script&lang=js"
export * from "./oneTimeLogin.vue?vue&type=script&lang=js"
import style0 from "./oneTimeLogin.vue?vue&type=style&index=0&id=8b215a18&prod&lang=scss&scoped=true"
import style1 from "./oneTimeLogin.vue?vue&type=style&index=1&id=8b215a18&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8b215a18",
  null
  
)

export default component.exports